import { useCallback } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import UIFlex from 'UIComponents/layout/UIFlex';
import UISelect from 'UIComponents/input/UISelect';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { useReviewContext } from './ReviewContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export function ReviewSelectInput({
  fieldKey,
  label,
  multi,
  options,
  placeholder,
  tooltip
}) {
  const {
    getFieldValidation,
    onUpdateReview,
    review
  } = useReviewContext();
  const {
    required,
    minSelected,
    maxSelected
  } = getFieldValidation('tags', fieldKey);
  const defaultValue = multi ? review.tags[fieldKey] : review.tags[fieldKey] ? review.tags[fieldKey][0] : null;
  let formattedOptions = options;
  if (maxSelected && review.tags[fieldKey]) {
    formattedOptions = options.map(option => Object.assign({}, option, {
      disabled: !maxSelected || review.tags[fieldKey].length >= maxSelected
    }));
  }
  let validationMessage;
  if (minSelected && review.tags[fieldKey] && review.tags[fieldKey].length !== 0 && review.tags[fieldKey].length < minSelected) {
    validationMessage = unescapedText('trellisEcosystem.reviews.minimumTags', {
      minSelected
    });
  }
  const handleUpdateReview = useCallback(({
    target: {
      value
    }
  }) => onUpdateReview({
    tags: {
      [fieldKey]: value
    }
  }), [fieldKey, onUpdateReview]);
  return /*#__PURE__*/_jsx(UIFormControl, {
    error: !!validationMessage,
    label: label,
    required: !!minSelected || required,
    tooltip: tooltip,
    validationMessage: validationMessage,
    children: /*#__PURE__*/_jsx(UIFlex, {
      direction: "row",
      wrap: "wrap",
      children: /*#__PURE__*/_jsx(UISelect, {
        defaultValue: defaultValue,
        error: !!validationMessage,
        multi: multi,
        onChange: handleUpdateReview,
        options: formattedOptions,
        placeholder: placeholder
      })
    })
  });
}